
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import UploadImg from '@/components/upload-img.vue';
  import {
    liveRoomProductRepositoryinit,
    liveRoomProductRepositorylist,
    liveRoomProductRepositoryrevoke,
    liveRoomProductRepositorydelete,
    liveRoomProductRepositoryresubmit,
    liveRoomProductRepositorychooseProductList,
    liveRoomProductRepositoryaddAndSubmit,
    liveRoomProductRepositorysubmitAgain
  } from "@/api/live"
	import {
    getSearchDate,
		nextDay,
    lastmonth
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      'slz-dialog': Dialog,
			Message,
      UploadImg,
    }
  })

  export default class ProductList extends Vue {
    private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private number = 0
    private keywords = ''
    private state = null
    private statelist = [
      {
				label: '全部',
				value: null
			}, {
				label: '未审核',
				value: 0
			}, {
				label: '审核中',
				value: 1
			}, {
				label: '审核失败',
				value: 3
			}
    ]
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false

    private rowmsg:any = {}
    private delShow = false
    private withdrawShow = false

    private pushShow = false
    private firstpush = true
    private keywords2 =  ''
    private filterTime = [getSearchDate(1,false)[0],nextDay(lastmonth(-1,1),-1)].join('/')
    private pageSize2 = 10
    private pageNo2 = 1
    private total2 = 0
    private tablelist2:any = []
    private tableloading2 = false
    private choosemsg:any = {}

    private auditShow = false
    private auditloading = false
    private form:any = {}
    private audittype = 1

    private mounted () {
      // console.log(this.filterTime)
      this.init()
      this.gettablelist()
    }

    private pageupdate(){
      this.init()
      this.gettablelist()
    }
    private async submitaudit(row){
      try{
        let res = await liveRoomProductRepositoryresubmit({
          Id:await row.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private auditagain(row){
      this.choosemsg = row
      this.audittype = 2
      let form = {
        ...JSON.parse(JSON.stringify(row)),
        onePrice:'',
        minPrice:'',
        maxPrice:'',
        oldPrice:'',
        newPrice:'',
        detaillink:'',
        otherlink:'',
      }
      form.ProductId = form.Id
      if(form.PriceType==1){
        form.onePrice = form.Price
      }else if(form.PriceType==2){
        form.minPrice = form.Price
        form.maxPrice = form.Price2
      }else if(form.PriceType==3){
        form.oldPrice = form.Price
      }
      form.detaillink = 'pages/mall/detail/detail?id=' + form.Id
      if(form.LinkType==0){
        form.otherlink = ''
      }else{
        form.otherlink = form.LinkUrl
      }
      this.form = JSON.parse(JSON.stringify(form))
      // console.log(row)
      // console.log(this.form)
      this.auditShow = true
    }
    private async init(){
      try{
        let res = await liveRoomProductRepositoryinit({})
        if(res.IsSuccess){
          this.number = res.Result.RemainingSubmitCount
        }
      }finally{
        //
      }
    }
    private withdrawrow(row){
      this.rowmsg = row
      this.withdrawShow = true
    }
    private delrow(row){
      this.rowmsg = row
      this.delShow = true
    }
    private strlength(str){
      let len = 0
      for(let i=0;i<str.length;i++){
        let c = str.charCodeAt(i)
        if((c >= 0x0001 && c < 0x007e) || (0xff60 <= c && c<= 0xff9f)){
          len++
        }else{
          len+=2
        }
      }
      return len
    }
    private testaudit(){
      let form = JSON.parse(JSON.stringify(this.form))
      let namelength = this.strlength(form.Name)/2
      if(!form.CoverImgUrl){
        this.$message.error('请上传商品封面图')
        return false
      }else if(!form.Name){
        this.$message.error('请输入商品名称')
        return false
      }else if(namelength<3||namelength>14){
        this.$message.error('商品名称必须为3~14个汉字')
        return false
      }else if((form.PriceType==1&&(!form.onePrice))||(form.PriceType==2&&
      (!form.minPrice||!form.maxPrice))||
        (form.PriceType==3&&(!form.oldPrice||!form.newPrice))){
      // console.log(form)
        this.$message.error('请输入商品价格')
        return false
      }else if(form.LinkType==1&&!form.otherlink){
        this.$message.error('请填写页面路径')
        return false
      }
      return true
    }
    private async confirmaudit(){
      if(!this.testaudit()) return
      this.auditloading = true
      try{
        let data:any = JSON.parse(JSON.stringify(this.form))
        if(this.audittype == 1){
          data.CoverImgUrl+='@!cut300_300'
        }
        if(data.PriceType == 1){
          data.Price = data.onePrice
          data.Price2 = data.onePrice
        }else if(data.PriceType == 2){
          data.Price = data.minPrice
          data.Price2 = data.maxPrice
        }else if(data.PriceType == 3){
          data.Price = data.oldPrice
          data.Price2 = data.newPrice
        }
        // console.log(data.maxPrice)
        let two = /^\d+(\.\d{1,2})?$/
        if(data.Price<0.01||data.Price>10000000||data.Price2<0.01||data.Price2>10000000||!two.test(data.Price)||!two.test(data.Price2)){
          // console.log(data.Price,data.Price2,'36')
          this.$message.error('请输入0.01~10000000的金额')
          return
        }
        if(data.LinkType==0){
          data.LinkUrl = data.detaillink
        }else{
          data.LinkUrl = data.otherlink
        }
        let res:any
        if(this.audittype == 1){
          res = await liveRoomProductRepositoryaddAndSubmit(data)
        }else{
          res = await liveRoomProductRepositorysubmitAgain(data)
        }
        if(res.IsSuccess){
          this.$message.success('已提交')
          this.auditShow = false
          this.pushShow = false
          this.pageupdate()
        }
      }finally{
        this.auditloading = false
      }
    }
    private uploadSuc(file){
      // console.log(123)
      this.form.CoverImgUrl = file[0]
    }
    private async confirmchoose(){
      if(!this.choosemsg.ProductId){
        this.$message.error('请先选择要提审的商品')
        return
      }
      this.audittype = 1
      this.form = {
        ProductId:this.choosemsg.ProductId,
        CoverImgUrl:this.choosemsg.MainImgUrl,
        Name:this.choosemsg.ProductName,
        PriceType:1,
        Price:'',
        Price2:'',
        LinkType:0,
        LinkUrl:'',
        onePrice:'',
        oldPrice:'',
        newPrice:'',
        minPrice:'',
        maxPrice:'',
        detaillink:'',
        otherlink:''
      }
      await this.redochoose()
      this.auditShow = true
      this.$forceUpdate()
      console.log(this.form)
    }
    private redochoose(){
      if(this.choosemsg.MinGroupPrice==this.choosemsg.MaxGroupPrice){
        this.form.PriceType = 1
        this.form.onePrice = this.choosemsg.MinGroupPrice
        this.form.oldPrice = ''
        this.form.newPrice = ''
        this.form.minPrice = ''
        this.form.maxPrice = ''
      }else{
        this.form.PriceType = 2
        this.form.onePrice = ''
        this.form.oldPrice = ''
        this.form.newPrice = ''
        this.form.minPrice = this.choosemsg.MinGroupPrice
        this.form.maxPrice = this.choosemsg.MaxGroupPrice
      }

      if(this.form.LinkType==0){
        this.form.detaillink = 'pages/mall/detail/detail?id=' + this.form.ProductId
        this.form.otherlink = ''
      }else {
        this.form.otherlink = ''
      }
      // console.log(this.form)
    }
    private chooseshop(row){
      this.choosemsg = row
    }
    private doSearch2(){
      this.pageNo2 = 1
      this.choosemsg = {}
      this.gettablelist2()
    }
    private changeCurrent2(e){
      this.pageNo2 = e
      this.gettablelist2()
    }
    private async gettablelist2(){
      try{
        this.tableloading2 = true
        let data:any = {
          ProductName:this.keywords2,
          Skip:(this.pageNo2-1)*this.pageSize2,
          Take:this.pageSize2,
        }
        if (this.filterTime){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await liveRoomProductRepositorychooseProductList(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results
          this.total2 = res.Result.Total
        }
      }finally{
        this.tableloading2 = false
      }
    }
    private async confirmwithdraw(){
      try{
        let res = await liveRoomProductRepositoryrevoke({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.withdrawShow = false
          this.pageupdate()
        }
      }finally{
        //
      }
    }
    private async confirmDelete(){
      try{
        let res = await liveRoomProductRepositorydelete({
          IdList:[this.rowmsg.Id]
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.pageupdate()
        }
      }finally{
        //
      }
    }
    private pushshop(){
      this.pushShow = true
      if(this.firstpush){
        this.keywords2 = ''
        this.filterTime = [getSearchDate(1,false)[0],nextDay(lastmonth(-1,1),-1)].join('/')
        this.firstpush = false
      }
      this.doSearch2()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Name:this.keywords,
          AuditStatus:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        let res = await liveRoomProductRepositorylist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.pageupdate()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.pageupdate()
    }
  }
